
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  addSalesOrders,
  updSalesOrders,
  getSalesOrdersDetail
} from "@/api/api-basic";
import { optionKey, getOptionList } from "@/api/api-dict";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class SalesOrderAdd extends Vue {
  private modalTitle = i18n.t("salesOrder.add");
  private formInline: objAny = {
    contractBillNumber: "",
    month: "",
    priority: "",
    projectName: "",
    projectNamePkId: "",
    sellerName: "",
    shippingAddress: "",
    specificationModel: []
  };
  private specificationModel: objAny = {
    number: "",
    projectName: "",
    projectNamePkId: "",
    requirementDesc: "",
    specificationDetails: ""
  };

  private priorityList: object[] = [];
  private monthList: object[] = [
    { itemValue: i18n.t("salesOrder.month1"), itemKey: 1 },
    { itemValue: i18n.t("salesOrder.month2"), itemKey: 2 },
    { itemValue: i18n.t("salesOrder.month3"), itemKey: 3 },
    { itemValue: i18n.t("salesOrder.month4"), itemKey: 4 },
    { itemValue: i18n.t("salesOrder.month5"), itemKey: 5 },
    { itemValue: i18n.t("salesOrder.month6"), itemKey: 6 },
    { itemValue: i18n.t("salesOrder.month7"), itemKey: 7 },
    { itemValue: i18n.t("salesOrder.month8"), itemKey: 8 },
    { itemValue: i18n.t("salesOrder.month9"), itemKey: 9 },
    { itemValue: i18n.t("salesOrder.month10"), itemKey: 10 },
    { itemValue: i18n.t("salesOrder.month11"), itemKey: 11 },
    { itemValue: i18n.t("salesOrder.month12"), itemKey: 12 }
  ];
  private orderList: object[] = [];
  private typeList: object[] = [];
  private formObj: objAny = {};
  private ruleInline: objAny = {
    contractBillNumber: [
      {
        required: true,
        message: i18n.t("salesOrder.contractBillNumberPl"),
        trigger: "blur"
      }
    ],
    projectName: [
      {
        required: true,
        message: i18n.t("productionOrder.projectNamePl"),
        trigger: "blur"
      }
    ],
    month: [
      { required: true, validator: regular.int, max: 999999, trigger: "blur" }
    ],
    priority: [
      {
        required: true,
        message: i18n.t("productionOrder.priorityPl"),
        trigger: "change"
      }
    ],
    specificationDetails: [
      {
        required: true,
        message: i18n.t("salesOrder.specificationDetailsPl"),
        trigger: "blur"
      }
    ],
    number: [
      { required: true, validator: regular.int, max: 999999, trigger: "blur" }
    ],
    requirementDesc: [
      {
        required: true,
        message: i18n.t("salesOrder.requirementDescPl"),
        trigger: "blur"
      }
    ],
    shippingAddress: [
      {
        required: true,
        message: i18n.t("salesOrder.shippingAddressPl"),
        trigger: "blur"
      }
    ],
    sellerName: [
      {
        required: true,
        message: i18n.t("salesOrder.sellerNamePl"),
        trigger: "blur"
      }
    ]
  };
  private itemData: objAny = {};
  private modalShow = false;
  private loading = false;
  private disabled = false;

  private pageType = "add";
  public open(item: objAny, type: string) {
    this.modalShow = true;
    if (item) {
      this.itemData = item;
    }
    this.pageType = type;
    this.resetForm();
    if (type != "add") {
      this.formInline.contractBillNumber = item.contractBillNumber;
      this.getSalesOrdersDetail();
    }
    if (type == "details") {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  public resetForm() {
    for (const i in this.formInline) {
      if (typeof this.formInline[i] == "string") {
        this.formInline[i] = "";
      }
    }
    this.handleReset();
    this.formInline.specificationModel = [];
    this.addModelClick();
  }
  public addModelClick() {
    const json: objAny = JSON.parse(JSON.stringify(this.specificationModel));
    this.formInline.specificationModel.push(json);
  }
  public delModelClick(index: number) {
    this.formInline.specificationModel.splice(index, 1);
  }
  async getSalesOrdersDetail() {
    const ret = await getSalesOrdersDetail({
      contractBillNumber: this.formInline.contractBillNumber
    });
    if (ret.status === this.$config.apiStatus) {
      const data: objAny = ret.data[0];
      this.formInline.contractBillNumber = data.contractBillNumber;
      this.formInline.month = data.month;
      this.formInline.priority = data.priority + "";
      this.formInline.projectName = data.projectName;
      this.formInline.projectNamePkId = data.projectNamePkId;
      this.formInline.sellerName = data.sellerName;
      this.formInline.shippingAddress = data.shippingAddress;

      if (data.specificationModel) {
        const specificationModel: object[] = [];
        data.specificationModel.map((item: objAny) => {
          specificationModel.push({
            number: item.number,
            projectName: item.projectName,
            projectNamePkId: item.projectNamePkId,
            requirementDesc: item.requirementDesc,
            specificationDetails: item.specificationDetails
          });
        });
        this.formInline.specificationModel = specificationModel;
      }
    }
  }
  async submitData(): Promise<void> {
    let ret;
    const json: objAny = JSON.parse(JSON.stringify(this.formInline));
    json.specificationModel.map((item: objAny) => {
      item.projectName = this.formInline.projectName;
      item.projectNamePkId = this.formInline.projectNamePkId;
    });
    this.loading = true;
    if (this.pageType == "add") {
      ret = await addSalesOrders(json);
    } else {
      ret = await updSalesOrders(json);
    }

    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  public handleReset() {
    this.formObj.resetFields();
  }
  async getOptionList() {
    const data = await getOptionList([optionKey.priority]);
    this.priorityList = data[optionKey.priority];
  }
  mounted() {
    this.getOptionList();
    this.$nextTick(() => {
      this.formObj = this.$refs["formValidate"];
    });
  }
}
